import { render } from "./warehouseInvoiceList.vue?vue&type=template&id=48701fc5&scoped=true"
import script from "./warehouseInvoiceList.vue?vue&type=script&lang=js"
export * from "./warehouseInvoiceList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48701fc5"]])

export default __exports__